import { ColorV2 } from "config/colors";
import { TypographyV2 } from "config/font";
import styled from "styled-components";

export const SalaryModalFormGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
  margin-top: 8px;

  @media (max-width: 520px) {
    grid-template-columns: minmax(0, 1fr);
  }
`;

export const SalaryModalHistorySection = styled.div`
  margin-top: 16px;
`;

export const SalaryModalHistoryTitle = styled.div`
  ${TypographyV2.b1}
  color: ${ColorV2.Blue1};
  margin-bottom: 8px;
`;

export const SalaryModalHistoryTable = styled.div`
  border: 1px solid ${ColorV2.Blue6};
  border-radius: 10px;
  overflow: hidden;
`;

interface HistoryRowProps {
  $columns?: 2 | 3 | 4;
}

export const SalaryModalHistoryRow = styled.div<HistoryRowProps>`
  display: grid;
  grid-template-columns: ${(props) => {
    if (props.$columns === 2) return "repeat(2, minmax(0, 1fr))";
    if (props.$columns === 3) return "1.2fr 1fr 48px";
    if (props.$columns === 4) return "1.2fr 1fr 1fr 48px";
    return "repeat(3, minmax(0, 1fr))";
  }};
  background: ${ColorV2.White};
`;

export const SalaryModalHistoryHeaderRow = styled(SalaryModalHistoryRow)`
  background: ${ColorV2.Blue7};
`;

interface HistoryCellProps {
  $isRightAligned?: boolean;
  $isCentered?: boolean;
}

export const SalaryModalHistoryCell = styled.div<HistoryCellProps>`
  ${TypographyV2.s1}
  color: ${ColorV2.Blue1};
  padding: 10px 12px;
  border-bottom: 1px solid ${ColorV2.Blue6};
  text-align: ${(props) => {
    if (props.$isCentered) return "center";
    if (props.$isRightAligned) return "right";
    return "left";
  }};
`;

export const SalaryModalHistoryHeaderCell = styled(SalaryModalHistoryCell)`
  ${TypographyV2.b2}
`;

export const SalaryModalError = styled.div`
  ${TypographyV2.s1}
  margin-top: 10px;
  color: ${ColorV2.NegativeRed};
`;

export const SalaryModalAddAction = styled.div`
  display: flex;
  grid-column: 1 / -1;
  justify-content: flex-end;
  margin-top: 4px;

  @media (max-width: 520px) {
    justify-content: flex-start;
  }
`;

export const SalaryModalDeleteButton = styled.button`
  align-items: center;
  background: transparent;
  border: 0;
  cursor: pointer;
  display: inline-flex;
  justify-content: center;
  padding: 0;

  &:disabled {
    cursor: default;
    opacity: 0.45;
  }
`;
